(function () {
    'use strict';

    angular
        .module('rms.common')
        .filter('selectedSort', selectedSort);

    function selectedSort($filter) {
        return function(sort, applied, template) {
            if (!applied) return sort.label;
            if (sort.name != applied.field) return sort.label;
            var icon = (applied.dir == 'asc') ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc';
            return $filter('stringFormat')(template, [sort.label, icon]);
        };
    }
})();